module.exports = antd.Avatar;